import { Alert, ConfigProvider } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { useUser } from "../../contexts/UserContext/UserContext";
import BannerAlertMessage, { BANNER_ALERT_COMPACT_CLASS } from "./BannerAlertMessage";

const isOnboardingInProgress = (pathname, company) => {
    if (pathname.startsWith("/onboarding")) {
        return true;
    }

    const completed = company?.onboardingSteps?.completed;
    return completed === false || completed === undefined;
};

const BannerAlert = () => {
    const { t } = useTranslation("banner");
    const { myCompanyData, state } = useUser();
    const [alerts, setAlerts] = useState([]);
    const history = useHistory();
    const location = useLocation();

    const hideAlertsForOnboarding = isOnboardingInProgress(location.pathname, myCompanyData);

    const checkData = useCallback(async () => {
        if (!state?.isAuthenticated || !myCompanyData) {
            setAlerts([]);
            return;
        }

        if (isOnboardingInProgress(location.pathname, myCompanyData)) {
            setAlerts([]);
            return;
        }

        try {
            const alertsArray = [];

            if (myCompanyData && !myCompanyData.defaultPaymentGateway) {
                alertsArray.push({
                    message: (
                        <BannerAlertMessage
                            actionLabel={t("stripeAlert.connectNow")}
                            onAction={() => {
                                history.push("/settings?menu=integration&tab=payment");
                            }}>
                            {t("stripeAlert.message")}{" "}
                            <span className="font-semibold">{t("stripeAlert.stripeAccount")}</span>{" "}
                            {t("stripeAlert.continuation")}
                        </BannerAlertMessage>
                    ),
                    className: BANNER_ALERT_COMPACT_CLASS,
                });
            }

            setAlerts(alertsArray);
        } catch (_error) {
            // ignore
        }
    }, [location.pathname, myCompanyData, state?.isAuthenticated, t, history]);

    useEffect(() => {
        checkData();
    }, [checkData]);

    const handleCloseAlert = (index) => {
        setAlerts((prev) => prev.filter((_, i) => i !== index));
    };

    if (hideAlertsForOnboarding) {
        return null;
    }

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: "#fac73c",
                    colorInfoBg: "#fac73c",
                    colorText: "#000000",
                    colorIcon: "#000000",
                },
            }}>
            {alerts.map((al, index) => (
                <Alert
                    key={index}
                    className={al.className}
                    message={al.message}
                    banner
                    type="info"
                    closable
                    afterClose={() => {
                        handleCloseAlert(index);
                    }}
                    showIcon={false}
                />
            ))}
        </ConfigProvider>
    );
};

export default BannerAlert;
